import request from "../request";

// GET NEWS-LETTER LIST API
export const getNewsLetterList = (params) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get("news-letter", { params })
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

// DELETE NEWS-LETTER BY ID
export const deleteNewsLetterById = (id) => {
  return new Promise(async (resolve, reject) => {
    await request
      .delete(`news-letter/${id}`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

// POST NEWS-LETTER API
export const postNewsLetterApi = async (data) => {
  try {
    const response = await request.post(`news-letter`, data);
    return response.data;
  } catch (error) {
    console.error("Error occurred in postNewsLetterApi:", error);
    throw error;
  }
};
